import React from "react";
import InputTextComponent from "../../../../components/forms/InputTextComponent";
import { Form, Col, Row } from "reactstrap";

const translator = require("../../../../utils/translator/translator");

class Charges extends React.Component 
{
    render() 
    {
        return (
            <Form>
                <Row className="mb-3">
                    <Col>
                        <InputTextComponent
                            autoComplete="off"
                            placeholder={translator.getLabel("venue_dialogue_service_charges")}
                            value={this.props.values.serviceCharges}
                            onValueChange={(value) => this.props.handleValueChange("serviceCharges", value)}
                            inputTextType="numeric"
                            error={this.props.error.fieldName === "serviceCharges" ? this.props.error.message : ""}
                            internalRef={this.props.inputFieldRef}
                        />
                    </Col>

                    <Col>
                        <InputTextComponent
                            autoComplete="off"
                            placeholder={translator.getLabel("venue_dialogue_delivery_charges")}
                            value={this.props.values.deliveryCharges}
                            onValueChange={(value) => this.props.handleValueChange("deliveryCharges", value)}
                            inputTextType="numeric"
                            error={this.props.error.fieldName === "deliveryCharges" ? this.props.error.message : ""}
                        />
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col>
                        <InputTextComponent
                            autoComplete="off"
                            placeholder={translator.getLabel("venue_dialogue_discount")}
                            value={this.props.values.discount}
                            onValueChange={(value) => this.props.handleValueChange("discount", value)}
                            inputTextType="numeric"
                            error={this.props.error.fieldName === "discount" ? this.props.error.message : ""}
                        />
                    </Col>
                    <Col></Col>
                </Row>
            </Form>
        );
    }

}

export default Charges